import { render, staticRenderFns } from "./CatalogoWiel.vue?vue&type=template&id=41de041b&scoped=true"
import script from "./CatalogoWiel.vue?vue&type=script&lang=js"
export * from "./CatalogoWiel.vue?vue&type=script&lang=js"
import style0 from "./CatalogoWiel.vue?vue&type=style&index=0&id=41de041b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41de041b",
  null
  
)

export default component.exports